import { css } from '@emotion/react';
import { breakpoints } from '@nike/nike-design-tokens';
const { podiumCdsBreakpointM } = breakpoints;

export const focusRingStyle = css`
  &:focus-visible {
    box-shadow: 0 0 0 2px var(--podium-cds-color-box-focus-ring);
  }
`;
export const navScrollable = 'nav-scrollable';
export const navMenuOpen = 'nav-menu-open';

export const desktopOnly = `min-width: ${podiumCdsBreakpointM}`;
export const mobileOnly = `max-width: ${parseInt(podiumCdsBreakpointM) - 1}px`;
